import React from 'react';
import { Grid, GridCol } from '@naf/grid';
import { animated, useSpring } from '@react-spring/web';
import useSelector from '@redux/typedHooks';
import CarSortDropdown from '../carSortDropdown/CarSortDropdown';
import CarSearch from '../carSearch/CarSearch';
import { DropdownArea, SearchWrapper, StyledGridCol, Wrapper } from './CarSearchSort.styles';

const CarSearchSort = () => {
  const { vehicleCounts } = useSelector((state) => state.cars);

  const { value } = useSpring({ value: vehicleCounts });

  return (
    <Wrapper>
      <Grid>
        <GridCol s="12" m="12" l="4" xl="4">
          <SearchWrapper>
            <CarSearch />
          </SearchWrapper>
        </GridCol>
        <StyledGridCol s="12" m="12" l="8" xl="8">
          <DropdownArea>
            <div>
              <animated.strong>{value.to((val) => Math.floor(val as number))}</animated.strong>
              <strong> treff</strong>
            </div>
            <CarSortDropdown />
          </DropdownArea>
        </StyledGridCol>
      </Grid>
    </Wrapper>
  );
};

export default CarSearchSort;
